import React, { useState, useEffect } from 'react'
import { LogSlider } from 'components/Pricing/PricingSlider/LogSlider'

const PricingSliderSection = ({
    title,
    value,
    setValue,
    cost,
    userNumber,
    icon,
    min,
    max,
    stepsInRange,
    marks,
    sliderComponent: SliderComponent,
    disabled = false,
}) => {
    const [isEnabled, setIsEnabled] = useState(!disabled)

    useEffect(() => {
        if (!isEnabled) {
            setValue(0)
        }
    }, [isEnabled, setValue])

    return (
        <div className="relative col-span-3 border-b border-dashed border-gray-accent-light p-2 pl-10">
            <div className="flex items-center">
                <span className="absolute top-3 left-3 flex h-5 w-5">{icon}</span>
                <input
                    type="checkbox"
                    checked={isEnabled}
                    onChange={() => setIsEnabled(!isEnabled)}
                    className="mr-2 ml-10"
                />
                <strong>{title}</strong>
            </div>
            {isEnabled && (
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
                    <span>
                        <span className="text-lg font-bold">{userNumber?.toLocaleString()}</span>{' '}
                        <span className="text-sm opacity-60">{title}</span>
                    </span>
                </div>
            )}
            <div className="flex flex-col pt-4 pb-6 lg:flex-row lg:items-center lg:justify-between">
                <SliderComponent
                    stepsInRange={stepsInRange}
                    marks={marks}
                    min={min}
                    max={max}
                    onChange={setValue}
                    value={value}
                    disabled={!isEnabled}
                />
                <span className="text-lg font-bold lg:ml-4">${cost.toLocaleString()}</span>
            </div>
        </div>
    )
}

export default PricingSliderSection
